module.exports = __webpack_public_path__ + "img/makysal.1a468919.jpeg";